const seoConfig = {
  /* ================= HOME ================= */
  home: {
    title: "Best Architects in Hyderabad | YV Reddy Associates",
    description:
      "YV Reddy Associates is a leading architectural design firm in Hyderabad offering residential, commercial & interior architecture services.",
    h1: "Top Architectural Design Company in Hyderabad",
    content: `
      YV Reddy Associates is a reputed architectural design firm in Hyderabad, known for creating
      innovative, functional, and sustainable architectural spaces for homes, offices, and commercial buildings.
    `,
    keywords:
      "architects in Hyderabad, architectural design company in Hyderabad, best architect in Hyderabad, residential architects Hyderabad, commercial architects Hyderabad",
  },

  /* ================= ABOUT ================= */
  about: {
    title: "About YV Reddy Associates | Architects in Hyderabad",
    description:
      "Learn about YV Reddy Associates, a trusted architectural firm in Hyderabad delivering innovative and sustainable design solutions.",
    h1: "About YV Reddy Associates",
    content: `
      YV Reddy Associates is a Hyderabad-based architectural firm focused on quality design,
      planning excellence, and client-centric architectural solutions.
    `,
    keywords:
      "architectural firm in Hyderabad, about architects Hyderabad, experienced architects Hyderabad",
  },

  /* ================= SERVICES (MAIN) ================= */
  services: {
    title: "Architectural Services in Hyderabad | YV Reddy Associates",
    description:
      "Comprehensive architectural services in Hyderabad including residential, commercial, interior design and planning.",
    h1: "Architectural Services in Hyderabad",
    content: `
      We offer end-to-end architectural services covering residential buildings,
      commercial projects, interior design, and architectural consultation.
    `,
    keywords:
      "architectural services Hyderabad, residential architects Hyderabad, commercial architects Hyderabad",
  },

  /* ================= SERVICES (INNER) ================= */
  serviceSingle: {
    title: "Architecture & Design Services | YV Reddy Associates",
    description:
      "Detailed architectural service information by YV Reddy Associates in Hyderabad.",
    h1: "Architectural Design Service",
    content: `
      Explore our specialized architectural services designed to meet specific
      residential and commercial project requirements.
    `,
    keywords:
      "architectural planning Hyderabad, architecture consultation Hyderabad, building planning services Hyderabad",
  },

  /* ================= PROJECTS (MAIN) ================= */
  projects: {
    title: "Architecture Projects in Hyderabad | YV Reddy Associates",
    description:
      "Explore residential and commercial architectural projects designed by YV Reddy Associates in Hyderabad.",
    h1: "Our Architectural Projects",
    content: `
      Our portfolio includes villas, apartments, commercial buildings,
      and interior architecture projects executed with design excellence.
    `,
    keywords:
      "architecture projects Hyderabad, architect portfolio Hyderabad",
  },

  /* ================= PROJECTS (INNER) ================= */
  projectSingle: {
    title: "Architectural Project Details | YV Reddy Associates",
    description:
      "Detailed architectural project overview by YV Reddy Associates.",
    h1: "Architectural Project Details",
    content: `
      Detailed insights into architectural design, planning,
      materials, and execution of our completed projects.
    `,
    keywords:
      "architectural projects Hyderabad, building design projects",
  },

  /* ================= BLOG (MAIN) ================= */
  blog: {
    title: "Architecture Blog | YV Reddy Associates",
    description:
      "Read architecture insights, design ideas, and industry updates by YV Reddy Associates.",
    h1: "Architecture Blog",
    content: `
      Stay updated with architectural trends, design concepts,
      and professional insights from our expert architects.
    `,
    keywords:
      "architecture blog Hyderabad, architectural design blog",
  },

  /* ================= BLOG (INNER) ================= */
  blogSingle: {
    title: "Architecture Insights & Articles | YV Reddy Associates",
    description:
      "In-depth architecture article by YV Reddy Associates.",
    h1: "Architecture Article",
    content: `
      Detailed discussion on architecture, planning,
      design strategies, and construction trends.
    `,
    keywords:
      "architecture articles, architectural insights Hyderabad",
  },

  /* ================= CONTACT ================= */
  contact: {
    title: "Contact Architects in Hyderabad | YV Reddy Associates",
    description:
      "Contact YV Reddy Associates for residential and commercial architectural design services in Hyderabad.",
    h1: "Contact YV Reddy Associates",
    content: `
      Get in touch with our architectural team to discuss
      your project requirements and design ideas.
    `,
    keywords:
      "contact architects Hyderabad, best architect Hyderabad contact",
  },
};

export default seoConfig;
